'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./_more-recommendations-button.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MoreRecommendationsButton(props) {
  var buttonClass = (0, _classnames2.default)('more-recommendations-button', props.isLeft ? 'left' : 'right');
  var iconClass = (0, _classnames2.default)('more-recommendations-button__icon', props.isLeft ? 'left' : 'right');

  return _react2.default.createElement(
    'div',
    { className: buttonClass, onClick: props.onClick },
    _react2.default.createElement('span', { className: iconClass })
  );
}

MoreRecommendationsButton.propTypes = {
  isLeft: _react.PropTypes.bool,
  onClick: _react.PropTypes.func.isRequired
};

exports.default = MoreRecommendationsButton;